import { HttpAdapter } from "../../main/adapters/HttpAdapter";

export class OperationStatus {
    HttpAdapter = new HttpAdapter();
    baseUrlDataCommunications = `${publicSettings.aws.baseUrls.dataCommunications}/data-communications`;

    constructor() {}

    async removeOne(_id) {
        if (!_id) return false;
        const response = await this.HttpAdapter.call(
            `${this.baseUrlDataCommunications}/operation-alert/remove-by-operationid`,
            { operationId: _id }
        );
        return response;
    }

    async removeMany({ companyId, status } = {}) {
        if (!Array.isArray(status) || !status.length)
            throw new Error(`Error params: status`);
        if (!companyId) throw new Error(`Error params: companyId`);
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataCommunications}/operation-alert/remove-by-companyId`,
                { companyId, status }
            );
            return response;
        } catch (error) {
            throw new Error(
                error?.message || "Erro ao remover operation alerts"
            );
        }
    }

    async listOperationAlerts(params) {
        return await this.HttpAdapter.call(
            `${this.baseUrlDataCommunications}/operation-alert/list`,
            params
        );
    }
}
